import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-wrapper" }
const _hoisted_2 = { class: "main-custom-row" }
const _hoisted_3 = { class: "main-left" }
const _hoisted_4 = { class: "pro-top-info-box" }
const _hoisted_5 = { class: "custom-row" }
const _hoisted_6 = { class: "pro-top-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "pro-top-content" }
const _hoisted_9 = { class: "pro-short-des" }
const _hoisted_10 = { class: "pro-link" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "dashboard-project-status" }
const _hoisted_13 = { class: "dashboard-chart-2" }
const _hoisted_14 = { class: "custom-row" }
const _hoisted_15 = { class: "main-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectStatus = _resolveComponent("ProjectStatus")!
  const _component_Chart4 = _resolveComponent("Chart4")!
  const _component_Chart2 = _resolveComponent("Chart2")!
  const _component_Issues = _resolveComponent("Issues")!
  const _component_Activity = _resolveComponent("Activity")!
  const _component_IssuePopup = _resolveComponent("IssuePopup")!

  return (_openBlock(), _createElementBlock("div", {
    class: "admin-project-details-page",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideClick && _ctx.handleOutsideClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.projectDetail.avatarUrls?.['48x48'],
                  alt: ""
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.projectDetail.name), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.projectDetail.description), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    id: "projectWebsiteLink",
                    href: _ctx.projectDetail.url,
                    target: "_blank"
                  }, _toDisplayString(_ctx.projectDetail.url), 9, _hoisted_11)
                ])
              ])
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "project-team-chat-section" }, null, -1)),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ProjectStatus)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_Chart4, {
                onOpenIssuesPopup: _ctx.handleOpenIssuesPopup,
                ref: "chart4Ref"
              }, null, 8, ["onOpenIssuesPopup"]),
              _createVNode(_component_Chart2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Issues, { ref: "issuesRef" }, null, 512),
          _createVNode(_component_Activity, { ref: "activityRef" }, null, 512)
        ])
      ])
    ]),
    _createVNode(_component_IssuePopup, {
      "popup-data": _ctx.popupData,
      "is-visible": _ctx.showIssuesPopup,
      onClose: _ctx.closeIssuesPopup
    }, null, 8, ["popup-data", "is-visible", "onClose"])
  ]))
}